/**
 * Safely parses a stringified GeoJSON Feature (IGeomBinItem.geom).
 *
 * Never throws: returns `null` when the input is falsy, when JSON.parse
 * throws, or when the parsed value is null/undefined or has no `id`
 * (which would otherwise crash callers like `drawRef.current.add()` or
 * `setFeatureProperty()`).
 */
export function parseGeom(geom: Maybe<string>): Nullable<GeoJSON.Feature> {
  if (!geom) {
    return null;
  }

  let parsed: Nullable<GeoJSON.Feature>;
  try {
    parsed = JSON.parse(geom);
  } catch {
    return null;
  }

  if (!parsed || parsed.id === undefined || parsed.id === null) {
    return null;
  }

  return parsed;
}
